/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Semantic_SearchInputs */

const es_settings_files_filters_semantic_search = /** @type {(inputs: Settings_Files_Filters_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda semántica`)
};

const en_settings_files_filters_semantic_search = /** @type {(inputs: Settings_Files_Filters_Semantic_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantic search`)
};

/**
* | output |
* | --- |
* | "Semantic search" |
*
* @param {Settings_Files_Filters_Semantic_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_semantic_search = /** @type {((inputs?: Settings_Files_Filters_Semantic_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Semantic_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_semantic_search(inputs)
	return en_settings_files_filters_semantic_search(inputs)
});
export { settings_files_filters_semantic_search as "settings.files.filters.semantic_search" }